import { render } from "./BrowseSearch.vue?vue&type=template&id=2dbdff04&scoped=true"
import script from "./BrowseSearch.vue?vue&type=script&lang=js"
export * from "./BrowseSearch.vue?vue&type=script&lang=js"

import "./BrowseSearch.vue?vue&type=style&index=0&id=2dbdff04&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbdff04"]])

export default __exports__